import React, { memo } from 'react';

import { AvatarWrapper } from './styles';
import IconTypes from 'components/Icon/IconTypes';
import Icon from 'components/Icon/Icon';

type ComponentProps = {
  icon: IconTypes;
  circle?: boolean;
  customStyle?: React.CSSProperties;
};

const Avatar: React.FunctionComponent<ComponentProps> = ({
  icon,
  circle = true,
  customStyle,
}) => {
  return (
    <AvatarWrapper circle={circle} style={customStyle && customStyle}>
      <Icon type={icon} />
    </AvatarWrapper>
  );
};

export default memo(Avatar);
